// components/FileUploadComponent.jsx
import React, { useRef } from 'react';
import { Box, Button, Chip, Typography } from '@mui/material';
import { CloudUpload, Close } from '@mui/icons-material';

const FileUpload = ({ uploadedFiles = [], onFileUpload, onRemoveFile }) => {
  const fileInputRef = useRef(null);

  const handleFileSelect = event => {
    const files = event.target.files;
    if (files && files.length > 0) {
      onFileUpload(files);
    }
    fileInputRef.current.value = '';
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="subtitle1" gutterBottom>
        Upload Documents
      </Typography>

      <input ref={fileInputRef} type="file" multiple onChange={handleFileSelect} style={{ display: 'none' }} />

      <Button variant="outlined" startIcon={<CloudUpload />} onClick={() => fileInputRef.current?.click()} sx={{ mb: 2 }}>
        Choose Files
      </Button>

      {uploadedFiles.length > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {uploadedFiles.map((fileObj, index) => {
            // 1. Try standard name tracking wrapper
            // 2. Try backend API convention key (docName)
            // 3. Try nested native file object (.file.name)
            // 4. Try direct native File object fallback
            const displayName =
              fileObj.name || fileObj.docName || fileObj.file?.name || fileObj.file?.docName || 'Selected File';

            // Safe identifier for key and deletion
            const trackingId = fileObj.id || fileObj.docID || index;

            return (
              <Chip
                key={trackingId}
                label={displayName}
                onDelete={() => onRemoveFile(trackingId)}
                deleteIcon={<Close />}
                variant="outlined"
              />
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default FileUpload;
